import React, { useContext } from 'react'
import { ModalContext } from 'providers/Modal'
import { showHideRecaptchaBadge } from 'utils/recaptchaToken'
import 'styles/close.scss'

const Close = () => {
  const { setActive } = useContext(ModalContext)
  const close = () => {
    showHideRecaptchaBadge(true)
    setActive(null)
  }
  return (
    <div data-testid="close_modal" className="layerClose" onClick={close} />
  )
}

export default Close
